import React, { Component } from "react";
import { InstantSearch } from "react-instantsearch-dom";
import qs from "qs";
import Container from "~/scripts/components/products/Container";
import SearchRow from "~/scripts/components/products/SearchRow";
import ResultsRow from "~/scripts/components/products/ResultsRow";
import { isEmpty } from "lodash";

class Products extends Component {
    constructor(props) {
        super(props);

        this.state = {
            searchState: this.readUrl(window.location.search)
        };
    }

    componentDidMount() {
        window.onpopstate = this.handlePopState;
    }

    readUrl = search => {
        let searchState = {};
        const parsed = qs.parse(search, {
            ignoreQueryPrefix: true,
            arrayFormat: "repeat"
        });

        searchState.query = parsed.query;

        if (parsed.application || parsed.brand || parsed.ipRating) {
            searchState.refinementList = {};

            if (parsed.application) {
                searchState.refinementList["family.applications"] =
                    parsed.application;
            }
            if (parsed.brand) {
                searchState.refinementList["family.brand"] = parsed.brand;
            }
            if (parsed.ipRating) {
                searchState.refinementList["family.ipRating"] = parsed.ipRating;
            }
        }

        if (parsed.category) {
            searchState.hierarchicalMenu = {};

            searchState.hierarchicalMenu["family.categories.lvl0"] =
                parsed.category;
        }

        if (parsed.availability) {
            searchState.menu = {};

            searchState.menu["availability"] = parsed.availability;
        }

        if (parsed.lumensMin || parsed.lumensMax) {
            searchState.range = {};
            const lumens = {};

            if (parsed.lumensMin) {
                lumens.min = parsed.lumensMin;
            }

            if (parsed.lumensMax) {
                lumens.max = parsed.lumensMax;
            }

            searchState.range.lumens = lumens;
        }

        return searchState;
    };

    handlePopState = () => {
        const searchState = this.readUrl(window.location.search);

        this.setState({ searchState });
    };

    handleSearchStateChange = nextSearchState => {
        const THRESHOLD = 700;
        const newPush = Date.now();
        const search = nextSearchState ? this.createUrl(nextSearchState) : "";

        if (this.state.lastPush && newPush - this.state.lastPush <= THRESHOLD) {
            window.history.replaceState(null, null, search);
        } else {
            window.history.pushState(null, null, search);
        }

        this.setState({ lastPush: newPush, searchState: nextSearchState });
    };

    createUrl = searchState => {
        const {
            query,
            refinementList,
            hierarchicalMenu,
            menu,
            range
        } = searchState;
        const search = {};

        if (query) {
            search.query = query;
        }

        if (refinementList) {
            const {
                "family.applications": application,
                "family.brand": brand,
                "family.ipRating": ipRating
            } = refinementList;

            if (application) {
                search.application = application;
            }

            if (brand) {
                search.brand = brand;
            }

            if (ipRating) {
                search.ipRating = ipRating;
            }
        }

        if (hierarchicalMenu) {
            const { "family.categories.lvl0": category } = hierarchicalMenu;

            if (category) {
                search.category = category;
            }
        }

        if (menu) {
            const { availability } = menu;

            if (availability) {
                search.availability = availability;
            }
        }

        if (range) {
            const { lumens } = range;

            if (lumens) {
                if (lumens.min) {
                    search.lumensMin = lumens.min;
                }

                if (lumens.max) {
                    search.lumensMax = lumens.max;
                }
            }
        }

        return isEmpty(search)
            ? window.location.pathname
            : `${window.location.pathname}?${qs.stringify(search, {
                  arrayFormat: "repeat"
              })}`;
    };

    render() {
        const { searchState } = this.state;
        const {
            ALGOLIA_APPLICATION_ID,
            ALGOLIA_API_KEY,
            ALGOLIA_PRODUCTS_INDEX_NAME
        } = window.__ENV_DATA__;

        return (
            <InstantSearch
                appId={ALGOLIA_APPLICATION_ID}
                apiKey={ALGOLIA_API_KEY}
                indexName={ALGOLIA_PRODUCTS_INDEX_NAME}
                createUrl={this.createUrl}
                searchState={searchState}
                onSearchStateChange={this.handleSearchStateChange}
                root={{ Root: Container }}
            >
                <SearchRow searchState={searchState} />
                <ResultsRow />
            </InstantSearch>
        );
    }
}

export default Products;



// WEBPACK FOOTER //
// ./public/assets/scripts/components/Products.js